module.exports = __webpack_public_path__ + "img/FASCINA.bbf6873a.png";